<template>
  <SettingsPageLayout>
    <DetailForm
      title="Notifications"
      description="Manage the notifications you receive for various events on Humaniz. By default, we have selected the notifications that we think are the most important to you, but feel free to make it your own."
      action="Save"
      @handleAction="updateUser"
      hidecancel="true"
      v-if="loaded"
    >
      <ToggleInput
        label="New Candidate Message"
        description="Triggered whenever a new message comes in for a candidate and it's been over 15 minutes without being read. Highly recommended as quick responses to candidates increase conversion rate significantly."
        :modelValue="settings.notifyOnNewMessage"
        @update:modelValue="settings.notifyOnNewMessage = $event"
      />
      <ToggleInput
        label="New Application Submitted"
        description="Triggered when a new application is created in Humaniz for your account. Highly recommended so you can quickly followup with a candidate that might have any questions as part of the application process."
        :modelValue="settings.notifyOnNewApplication"
        @update:modelValue="settings.notifyOnNewApplication = $event"
      />
      <ToggleInput
        label="New Candidate or Teammate Event Scheduled"
        description="Triggered whenever a Candidate or Teammate schedules a new event with you."
        :modelValue="settings.notifyOnEventScheduled"
        @update:modelValue="settings.notifyOnEventScheduled = $event"
      />
      <ToggleInput
        label="Scheduled Event Email Reminder"
        description="Triggered whenever a Candidate or Teammate has an upcoming scheduled event with you."
        :modelValue="settings.notifyOnEventReminderEmail"
        @update:modelValue="settings.notifyOnEventReminderEmail = $event"
      />
      <ToggleInput
        label="Scheduled Event SMS Reminder"
        description="Triggered whenever a Candidate or Teammate has an upcoming scheduled event with you."
        :modelValue="settings.notifyOnEventReminderSMS"
        @update:modelValue="settings.notifyOnEventReminderSMS = $event"
      />
      <ToggleInput
        label="Daily Recap Email"
        description="A daily email summarizing changes to your hiring pipeline over the last day."
        :modelValue="settings.notifyDailyPipelineReport"
        @update:modelValue="settings.notifyDailyPipelineReport = $event"
      />
      <ToggleInput
        label="Weekly Report Email"
        description="A weekly email highlighting recommended actions based on the previous week."
        :modelValue="settings.notifyWeeklyDigestReport"
        @update:modelValue="settings.notifyWeeklyDigestReport = $event"
      />
      <ToggleInput
        label="Stale Jobs Notification"
        description="A notification when you have jobs that haven't been updated in over 30 days."
        :modelValue="settings.notifyOnStaleJobs"
        @update:modelValue="settings.notifyOnStaleJobs = $event"
      />
    </DetailForm>
  </SettingsPageLayout>
</template>

<script>
import { mapState } from 'vuex';
import SettingsPageLayout from '../../SettingsPageLayout/index.vue';
import DetailForm from '../../shared/DetailForm.vue';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
  },
  data() {
    return {
      loaded: false,
      settings: {
        notifyOnNewMessage: false,
        notifyOnNewApplication: false,
        notifyDailyPipelineReport: false,
        notifyWeeklyDigestReport: false,
        notifyOnEventScheduled: false,
        notifyOnEventReminderEmail: false,
        notifyOnEventReminderSMS: false,
        notifyOnStaleJobs: false,
      },
    };
  },
  computed: {
    ...mapState({
      user: state => state.general.currentUser,
      currentUserNotificationSettings: state => state.general.currentUserNotificationSettings,
    }),
  },
  async mounted() {
    await this.getUser();
  },
  methods: {
    async getUser() {
      await this.$store.dispatch('general/loadCurrentUser');
      this.settings = {
        notifyOnNewMessage: this.currentUserNotificationSettings.notifyOnNewMessage,
        notifyOnNewApplication: this.currentUserNotificationSettings.notifyOnNewApplication,
        notifyDailyPipelineReport: this.currentUserNotificationSettings.notifyDailyPipelineReport,
        notifyWeeklyDigestReport: this.currentUserNotificationSettings.notifyWeeklyDigestReport,
        notifyOnEventScheduled: this.currentUserNotificationSettings.notifyOnEventScheduled,
        notifyOnEventReminderEmail: this.currentUserNotificationSettings.notifyOnEventReminderEmail,
        notifyOnEventReminderSMS: this.currentUserNotificationSettings.notifyOnEventReminderSMS,
        notifyOnStaleJobs: this.currentUserNotificationSettings.notifyOnStaleJobs,
      };
      this.loaded = true;
    },
    async updateUser() {
      this.$store.commit('general/showLocalLoadingSpinner');
      await this.$store.dispatch('general/updateUser', {
        user: this.user,
        updatedUserAttributes: {
          notify_on_new_message: this.settings.notifyOnNewMessage,
          notify_on_new_application: this.settings.notifyOnNewApplication,
          notify_daily_pipeline_report: this.settings.notifyDailyPipelineReport,
          notify_weekly_digest_report: this.settings.notifyWeeklyDigestReport,
          notify_on_event_scheduled: this.settings.notifyOnEventScheduled,
          notify_on_event_reminder_email: this.settings.notifyOnEventReminderEmail,
          notify_on_event_reminder_sms: this.settings.notifyOnEventReminderSMS,
          notify_on_stale_jobs: this.settings.notifyOnStaleJobs,
        },
      });
      this.$store.commit('general/hideLocalLoadingSpinner');
      this.$store.commit('general/showAlert', {
        alertType: 'success',
        alertTitle: 'Notifications updated',
        alertDescription: 'Your Notifications were successfully updated.  Use the button below to dismiss this alert.',
      });
    },
  },
};
</script>
